// API helpers for CDM Documents settings (split from CDMDocumentsSettings.jsx)
export const API_URL = process.env.REACT_APP_BACKEND_URL || '';
export const PIPELINE_API = process.env.REACT_APP_BACKEND_URL;

// Authenticated fetch wrapper (Step 1 security hardening): RAG admin endpoints
// require a Bearer token. FormData bodies keep browser-set multipart headers.
export const authedFetch = (url, init = {}) => {
  const headers = { Authorization: `Bearer ${localStorage.getItem('token')}`, ...(init.headers || {}) };
  if (!(init.body instanceof FormData) && !headers['Content-Type']) {
    headers['Content-Type'] = 'application/json';
  }
  return fetch(url, { ...init, headers });
};
